import React from 'react';
import '../styles/instructors.css';

const InstructorsPage = () => {
  return (
    <div className="page-wrapper instructors-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Our Instructors</h1>
          <p className="page-subtitle">
            Meet the dedicated team behind our dojo.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="instructors-list">
          {[
            {
              name: 'Paul Rees',
              rank: '6th Dan Black Belt – Founder & Chief Instructor',
              story: 'I have been training in karate for over 40 years and teaching for more than three decades. Over the years, I\'ve had the honour of being featured in Traditional Karate magazine (December 1996) and representing England as part of the national karate team, competing in various countries before retiring from active competition. I was proud to receive the British National Martial Artist Award for two consecutive years (1993–1995). I currently hold a 6th Dan with the English Karate Organisation and am a qualified instructor with NVQ Level 3 and HSE First Aid + Medic experience.',
              image: 'https://customer-assets.emergentagent.com/job_a492b9e1-50ce-460c-bf98-443f978136bb/artifacts/n820af0y_7759.jpg'
            },
            {
              name: 'Roy Inns',
              rank: 'Black Belt Instructor',
              story: 'Hi, I\'m Roy Inns, one of the black belt instructors at San Kai Karate Association. My karate journey began back in August 1981 when I was a child, and I rejoined the world of karate in January 2019 through this club, inspired by my daughter, who was a student at the time. Since then, I\'ve never looked back. One of my favourite parts of being in the club is our summer camps – packed with fun, fitness, and karate training.',
              image: 'https://customer-assets.emergentagent.com/job_a492b9e1-50ce-460c-bf98-443f978136bb/artifacts/npyby32l_7766.jpg'
            },
            {
              name: 'Samantha Allen',
              rank: 'Black Belt Instructor',
              story: 'I\'ve been dedicated to karate since 2004 and earned my black belt in 2009. My training has been guided by several experienced Sensei in both traditional Wado Ryu and Wado Ryu–based styles. In 2008, I joined San Kai Karate and have continued to deepen my knowledge and passion for the art ever since. Throughout my martial arts journey, I\'ve taken part in many competitions, with a special focus on Kata. I\'m a qualified Level 4 teacher and hold certifications in Autism Awareness for both adults and children. Professionally, I work as a Quality Manager for apprenticeships and also hold a full DBS certificate and Level 2 Emergency First Aid qualification.',
              image: 'https://customer-assets.emergentagent.com/job_a492b9e1-50ce-460c-bf98-443f978136bb/artifacts/uag8tq81_7771.jpg'
            }
          ].map((instructor, index) => (
            <div key={index} className="instructor-card">
              <div className="instructor-image">
                <img src={instructor.image} alt={instructor.name} />
              </div>
              <div className="instructor-info">
                <h3 className="instructor-name">{instructor.name}</h3>
                <p className="instructor-rank">{instructor.rank}</p>
                <p className="instructor-story">{instructor.story}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstructorsPage;